<template>
  <div>
    <v-card>
      <v-row>
        <v-col>
          <v-card-title>Employee Statutory Informations</v-card-title>
        </v-col>
   
        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-btn
            class="mx-3"
            color="primary"
            :loading="loading"
            @click="generate"
          >
            generate
          </v-btn>
        </v-col>
      </v-row>
    </v-card> 
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loading: false,
      }
    },
    methods: {
      generate () {
        this.loading = true

        this.$api.payrollExports().employeeStatutoryExport()
          .then((res) => {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', 'Employee Statutory Information.xlsx') 
            link.click()
            this.loading = false

            this.$snack({ message: 'Employee statutory information downloaded successfully' })
          }).catch(e => {
            this.loading = false
            if (e.response.status === 400) {
              this.$snack({ 
                color: 'error',
                message: e.response.data.status, 
              })
            }
          })
      },
    },
  }
</script>
